import window from '../injectChromeObject'

export function getExtensionVersion() {
  return window.chrome?.runtime?.getManifest?.()?.version ?? null
}
